export default "__VITE_ASSET__7c5eae9b__"